import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTicketTemplates } from '../../../services/ticketTemplates';
import { ITicketTemplate } from '../../../services/ticketTemplates/types';

export const ThunkGetTicketTemplates = createAsyncThunk<ITicketTemplate[]>(
  `${storeResources.TICKETS}/getTicketTemplates`,
  () => getTicketTemplates().then(res => res.data),
);
